import { PropsWithChildren, ReactElement } from 'react';
import * as stylex from '@stylexjs/stylex';
import type { StyleXStyles } from '@stylexjs/stylex';
import '../theme/Radius.stylex';
import { CornerRadius } from '../theme/Radius.stylex';
import '../theme/Spaces.stylex';
import { Padding } from '../theme/Spaces.stylex';
import '../theme/Fonts.stylex';
import { FontFamily, FontSize, FontWeight } from '../theme/Fonts.stylex';
import '../theme/Colors.stylex';
import { ColorNeutral } from '../theme/Colors.stylex';
import { Inline } from './Inline';
export type CanaryCardPadding = 'normal' | 'large' | 'xxlarge';
export type CanaryCardProps = PropsWithChildren<{
  padding?: CanaryCardPadding;
  stylex?: StyleXStyles;
}>;
const cardStyles = {
  root: {
    "position-kVAEAm": "position-x1n2onr6",
    "backgroundColor-kWkggS": "backgroundColor-x12peec7",
    "borderRadius-kaIpWk": "borderRadius-x1qd5jr3",
    $$css: "wino-gc:src/resources/layout-and-structure/CanaryCard.tsx:19"
  },
  normal: {
    "padding-kmVPX3": "padding-xzp7fdy",
    $$css: "wino-gc:src/resources/layout-and-structure/CanaryCard.tsx:24"
  },
  large: {
    "padding-kmVPX3": "padding-xzwvdci",
    $$css: "wino-gc:src/resources/layout-and-structure/CanaryCard.tsx:27"
  },
  xxlarge: {
    "padding-kmVPX3": "padding-xe3jccn",
    $$css: "wino-gc:src/resources/layout-and-structure/CanaryCard.tsx:30"
  }
};
export function CanaryCard({
  children,
  padding = 'normal',
  stylex: style
}: CanaryCardProps): ReactElement {
  return <div {...stylex.props(cardStyles.root, cardStyles[padding], style)}>
      {children}
    </div>;
}
export type CanaryCardHeaderProps = PropsWithChildren;
export function CanaryCardHeader(props: CanaryCardHeaderProps): ReactElement {
  return <Inline space="none">{props.children}</Inline>;
}
export type CanaryCardTitleProps = PropsWithChildren;
const {
  titleStyle
} = {
  titleStyle: {
    "fontFamily-kMv6JI": "fontFamily-x111x8ze",
    "fontSize-kGuDYH": "fontSize-x1vcisby",
    "fontWeight-k63SB2": "fontWeight-x168tpfk",
    "lineHeight-kLWn49": "lineHeight-xo5v014",
    "color-kMwMTN": "color-x1w1nkkj",
    $$css: "wino-gc:src/resources/layout-and-structure/CanaryCard.tsx:56"
  }
};
export function CanaryCardTitle(props: CanaryCardTitleProps): ReactElement {
  return <span {...stylex.props(titleStyle)}>{props.children}</span>;
}